import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Password from "../../assets/images/password.svg";
import { makeStyles, Typography } from "@material-ui/core";
import CCRCommonHeader from "../common/CCRCommonHeader";
import { useStyles } from "./CCRStyles";


function IsEmailValid(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isValid = false;
    if (re.test(email)) {
        isValid = true;
    }
    return isValid;
}
const styles = makeStyles((theme) => ({
    signInStatus: {
        "margin-top": "0px",
        "margin-bottom": "12px",
        "text-align": "left",
        "margin-left": "5px",
    },

    signInStatusRed: {
        "margin-top": "0px",
        "margin-bottom": "12px",
        "text-align": "left",
        "margin-left": "5px",
        "color": "red"
    },
}));

function CCRForgotPassword(props) {
    const { signInStatus, signInStatusRed } = styles();

    const ccrStyles = useStyles();

    const [emailAddressError, setEmailAddressError] = useState("");

    function emailChange(e) {
        if (e.target.value == null || e.target.value === undefined || e.target.value.trim() === "") {
            setEmailAddressError("Please enter your email");
        }
        else if (!IsEmailValid(e.target.value.trim())) {
            setEmailAddressError("Please enter a valid email address");
        }
        else {
            setEmailAddressError("");
        }
        props.onChange(e);
    }

    function forgotPassword() {
        const { email } = props.formState;
        const verified = verification(email);
        if (verified) {
            props.NotificationForgotPassword();
        }
    }

    function verification(username) {
        let isVerified = true;
        if (username == null || username === undefined || username.trim() === "") {
            setEmailAddressError("Please enter your email");
            isVerified = false;
        } else if (!IsEmailValid(username.trim())) {
            setEmailAddressError("Please enter a valid email address");
            isVerified = false;
        } else {
            setEmailAddressError("");
        }

        return isVerified;
    }

    function onEnter(e) {
        forgotPassword();
        e.preventDefault();
        e.stopPropagation();
        return true;
    }

    return (
        <CCRCommonHeader customTemplate={props.customTemplate} header="Forgot Password" headerIcon={Password} appType={props.appConfig.appType}>
            <div style={{ padding: '10px 0px 20px' }}>
                <div style={{ fontSize: '14px' }}>
                    Provide the email address associated with your account to reset your password.
                </div>
            </div>
            <div style={{ padding: '10px 0px 40px' }}>
                <div style={{ width: '365px' }}>
                    <Typography variant="caption">Email Address</Typography>
                    <TextField
                        fullWidth
                        name="email"
                        variant="standard"
                        autoFocus
                        placeholder="Enter your email"
                        classes={{ root: ccrStyles.customTextField }}
                        pattern="^[a-zA-Z0-9.!#$%&’'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                        error={(emailAddressError)}
                        helperText={(emailAddressError)
                            ? emailAddressError
                            : ''
                        }
                        onChange={emailChange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                onEnter(e)
                            }
                        }}

                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ background: '#4785FF', height: '25px', width: '300px', borderRadius: '20px', cursor: 'pointer', marginTop: '20px', textAlign: 'center' }} onClick={forgotPassword}>
                        <span style={{ color: 'white', fontWeight: 'bold' }}>SEND RESET EMAIL</span>
                    </div>
                    <div style={{ fontSize: '12px', textAlign: 'center', paddingTop: '10px', height: '30px' }}>
                        {(props.forgotPwdStatus)
                            ? <span className={props.forgotPwdStatus.indexOf("email") !== -1 ? ` ${signInStatusRed}` : ` ${signInStatus}`}>{props.forgotPwdStatus}</span>
                            : null
                        }
                    </div>
                </div>
            </div>
            <div style={{ paddingBottom: '5px', fontSize: '14px' }}>
                <div>
                    Remember your password ? <span style={{ color: '#4785FF', cursor: 'pointer', textDecorationLine: 'underline', paddingLeft: '5px' }} onClick={props.cancel}>back to Sign In</span>
                </div>
            </div>
        </CCRCommonHeader>
    )
}

export default CCRForgotPassword;
